import { render, staticRenderFns } from "./DefinitionSetup.vue?vue&type=template&id=3779337a&scoped=true&"
import script from "./DefinitionSetup.vue?vue&type=script&lang=ts&"
export * from "./DefinitionSetup.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionSetup.vue?vue&type=style&index=0&id=3779337a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779337a",
  null
  
)

export default component.exports